import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';
import {
    GetRuntimeConfigurationResponse,
    RuntimeConfigurationListResponse,
    RuntimeConfigurationVersionListItem,
} from '../../../pages/RuntimeConfiguration/runtimeConfiguration.types';

const DEFAULT_PAGE_SIZE = 20;

const ListRuntimeConfigurations = (params?: {
    pageNumber?: number;
    pageSize?: number;
}): Promise<RuntimeConfigurationListResponse> =>
    request({
        url: ApiURL.Query.RUNTIME_CONFIGURATION_LIST,
        method: RequestType.GET,
        params: {
            PageNumber: params?.pageNumber ?? 1,
            PageSize: params?.pageSize ?? DEFAULT_PAGE_SIZE,
        },
    });

const GetRuntimeConfiguration = (key: string, version?: number): Promise<GetRuntimeConfigurationResponse> =>
    request({
        url: ApiURL.Query.RUNTIME_CONFIGURATION_GET(key),
        method: RequestType.GET,
        params: version != null ? { version } : undefined,
    });

const ListRuntimeConfigurationVersions = (key: string): Promise<RuntimeConfigurationVersionListItem[]> =>
    request({
        url: ApiURL.Query.RUNTIME_CONFIGURATION_VERSIONS(key),
        method: RequestType.GET,
    });

const RuntimeConfigurationQuery = {
    ListRuntimeConfigurations,
    GetRuntimeConfiguration,
    ListRuntimeConfigurationVersions,
};

export default RuntimeConfigurationQuery;
